import { render, staticRenderFns } from "./discountForm.vue?vue&type=template&id=07ccd7fa&scoped=true"
import script from "./discountForm.vue?vue&type=script&lang=js"
export * from "./discountForm.vue?vue&type=script&lang=js"
import style0 from "./discountForm.vue?vue&type=style&index=0&id=07ccd7fa&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ccd7fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07ccd7fa')) {
      api.createRecord('07ccd7fa', component.options)
    } else {
      api.reload('07ccd7fa', component.options)
    }
    module.hot.accept("./discountForm.vue?vue&type=template&id=07ccd7fa&scoped=true", function () {
      api.rerender('07ccd7fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/rights/fee/dealer_acount/form/discountForm.vue"
export default component.exports